"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
var deepmerge_1 = __importDefault(require("deepmerge"));
var core_1 = require("../../../../shared/core");
var components_1 = require("../../../../shared/core/components");
var keys = {
    meterReadsNoData: 'meterReadingsSummary.meterReadsNoData',
    meterReadsLink: 'meterReadingsSummary.meterReadsLink',
    meterReadsNextRead: 'meterReadingsSummary.meterReadsNextRead',
    meterReadsLastRead: 'meterReadingsSummary.meterReadsLastRead',
    meterReadsStatusOk: 'meterReadingsSummary.meterReadsStatusOk',
    meterReadsStatusDue: 'meterReadingsSummary.meterReadsStatusDue',
    meterReadsStatusWarning: 'meterReadingsSummary.meterReadsStatusWarning',
    meterReadsStatusSmartOk: 'meterReadingsSummary.meterReadsStatusSmartOk',
    meterReadsStatusSmartOkWithManualRead: 'meterReadingsSummary.meterReadsStatusSmartOkWithManualRead',
    meterReadsStatusSmartWarning: 'meterReadingsSummary.meterReadsStatusSmartWarning',
    meterReadsHeading: 'meterReadingsSummary.meterReadsHeading',
    smartMeterOkMessage: 'meterReadingsSummary.smartMeterOkMessage',
};
var defaultTranslations = (0, deepmerge_1.default)(core_1.translations, {
    en: {
        meterReadingsSummary: {
            meterReadsNoData: '<Heading3>Your meter readings</Heading3>',
            meterReadsLink: "Send a meter reading",
            meterReadsNextRead: "<Strong>Best day for next reading:</Strong>",
            meterReadsLastRead: "<P><Small>Last reading: {{lastReadingDateFormatted}}</Small></P>",
            meterReadsStatusOk: "<P><Strong>They\u2019re up to date. Thanks!</Strong></P>",
            meterReadsStatusDue: "<P><Strong>For an accurate bill, it\u2019s time to send a new reading</Strong></P>",
            meterReadsStatusWarning: "<P><Strong>It\u2019s been over 30 days since we had a new meter reading</Strong></P>",
            meterReadsStatusSmartOk: "<P><Strong>Your smart meter is sending them to us automatically. Nice one!</Strong></P>",
            meterReadsStatusSmartOkWithManualRead: "<P><Strong>We couldn't get a reading from your smart meter - but we\u2019ve got your recent manual reading. Thanks!</Strong></P>",
            meterReadsStatusSmartWarning: "<P><Strong>We couldn't get a reading from your smart meter. Mind sending one manually?</Strong></P>",
            meterReadsHeading: 'Your meter readings',
            smartMeterOkMessage: "<P>You don't need to do anything.</P>",
        },
    },
});
var defaultOptions = {
    keys: keys,
    defaultTranslations: defaultTranslations,
    components: {
        Monospace: components_1.Monospace,
    },
};
exports.defaultOptions = defaultOptions;
